<template>
  <div class="view pa24">
    <el-dialog
      :title="title"
      width="1400px"
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="closeDialog"
    >
      <el-form :model="ruleForm" label-width="140px" class="ruleForm">
        <!-- 主产品选择 -->
        <el-form-item label="产品类型:" prop="classIdAttr">
          <el-cascader
            style="width: 100%"
            v-model="ruleForm.classIdAttr"
            placeholder="选择产品类型"
            :options="mainProducts"
            :emitPath="false"
            filterable
            :props="{
              value: 'id',
              label: 'allName',
              children: 'children',
              checkStrictly: true,
            }"
            @change="selectItem"
          ></el-cascader>
          <label style="color: red">一级为产品，二级为组件，三级为零件</label>
        </el-form-item>
        <div
          v-for="(accessory, accessoryIndex) in ruleForm.accessories"
          :key="accessoryIndex"
          :class="['accessory1', accessoryIndex % 2 === 0 ? 'even' : 'odd']"
        >
          <el-form-item :label="label">
            <el-cascader
              style="width: 70%"
              v-model="ruleForm.accessories[accessoryIndex]"
              placeholder="选择"
              :options="secondProducts[ruleForm.type]"
              filterable
              :emitPath="false"
              :props="{ value: 'id', label: 'allName', children: 'children' }"
            ></el-cascader>

            <el-input-number
              v-model="ruleForm.number[accessoryIndex]"
              :min="1"
              style="margin-left: 20px"
            ></el-input-number>
            <el-button type="danger" @click="deleteComponent(accessoryIndex)"
              >x</el-button
            >
          </el-form-item>
        </div>

        <el-button type="primary" @click="addComponent"
          >+{{ button }}</el-button
        >
        <div class="dialog-footer" style="text-align: right">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button class="btncss" @click="confirmAddCustomer"
            >绑 定</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { fetchClassLevelTree } from "@/api/customPageClass.js";
import { save, list } from "@/api/boomClass.js";

export default {
  name: "addPageClass",
  components: {},
  props: [],
  data() {
    return {
      dialogVisible: false,
      title: "",
      button: "添加",
      label: "选择",
      mainProducts: [],
      secondProducts: {
        1: [],
        2: [],
      },
      ruleForm: {
        type: 1,
        classIdAttr: [],
        accessories: [],
        number: [],
      },
    };
  },
  mounted() {
    this.getAllClass();
  },
  methods: {
    getAllClass() {
      fetchClassLevelTree({ type: 0, level: 0 }).then((res) => {
        this.mainProducts = res.data;
      });
      fetchClassLevelTree({ type: 0, level: 1 }).then((res) => {
        this.secondProducts[1] = res.data;
      });
      fetchClassLevelTree({ type: 0, level: 2 }).then((res) => {
        this.secondProducts[2] = res.data;
      });
    },
    getSecondList(classId) {
      list({ classId: classId }).then((res) => {
        if (res.code === 200) {
          for (let i = 0; i < res.data.length; i++) {
            this.ruleForm.accessories.push(JSON.parse(res.data[i].classAttr));
            this.ruleForm.number.push(res.data[i].num);
          }
        }
      });
    },
    openDialog(row) {
      this.getAllClass();
      this.dialogVisible = true;
      this.resetForm();
      if (null === row) {
        this.title = "添加BOM清单";
      } else {
        this.title = "修改BOM清单";
        this.ruleForm.type = row.type + 1;
        if (1 === this.ruleForm.type) {
          this.button = "添加组件";
          this.label = "选择组件";
        } else {
          this.button = "添加零件";
          this.label = "选择零件";
        }
        this.ruleForm.classIdAttr = JSON.parse(row.classAttr);
        for (let i = 0; i < row.items.length; i++) {
          this.ruleForm.accessories.push(JSON.parse(row.items[i].classAttr));
          this.ruleForm.number.push(row.items[i].num);
        }
      }
    },
    closeDialog() {
      this.dialogVisible = false;
      this.resetForm();
    },
    resetForm() {
      this.ruleForm.type = 1;
      this.ruleForm.classIdAttr = [];
      this.ruleForm.accessories = [];
      this.ruleForm.number = [];
    },
    selectItem(v) {
      let length = v.length;
      this.ruleForm.type = length;
      this.ruleForm.ids = [];
      this.ruleForm.accessories = [];
      this.ruleForm.number = [];
      if (1 === length) {
        this.button = "添加组件";
        this.label = "选择组件";
      } else {
        this.button = "添加零件";
        this.label = "选择零件";
      }
      this.getSecondList(v[length - 1]);
    },
    addComponent() {
      this.ruleForm.accessories.push(null);
      this.ruleForm.number.push(1);
      this.ruleForm.ids.push(0);
    },
    deleteComponent(index) {
      this.ruleForm.accessories.splice(index, 1);
      this.ruleForm.number.splice(index, 1);
      this.ruleForm.ids.splice(index, 1);
    },

    confirmAddCustomer() {
      save(this.ruleForm).then((res) => {
        if (res.code === 200) {
          this.$message({
            type: "success",
            message: "操作成功",
          });
          this.$emit("getList");
          this.closeDialog();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.component {
  margin-bottom: 10px;

  &.even {
    background-color: #f5f5f5;
  }

  &.odd {
    background-color: #fff;
  }
}

.accessory {
  margin-bottom: 10px;
  padding-left: 20px;

  &.even {
    background-color: #f5f5f5;
  }

  &.odd {
    background-color: #fff;
  }
}

.sub-accessory {
  margin-bottom: 10px;
  padding-left: 40px;

  &.even {
    background-color: #f5f5f5;
  }

  &.odd {
    background-color: #fff;
  }
}
</style>
